export type Role = {
  id: string;
  title: string;
  description: string;
  image: string;
};

export const roles: Role[] = [
  {
    id: "ai",
    title: "AI Programmers",
    description:
      "Highly skilled AI programmers specialising in automation, data processing, machine learning, and enterprise-grade systems.",
    image: "/assets/optimized/ai-programmers",
  },
  {
    id: "web",
    title: "Web Developers",
    description:
      "Web developers available for large and small projects with considerable knowledge and expertise in UK consumer data.",
    image: "/assets/optimized/web-developer",
  },
  {
    id: "qa",
    title: "Quality Assurance",
    description:
      "Quality assurance specialists providing manual and automated testing to ensure accuracy, compliance, and operational reliability.",
    image: "/assets/optimized/quality-asurance",
  },
  {
    id: "db",
    title: "Database Administrators",
    description:
      "Database administrators experienced in secure data storage, performance optimisation, and regulatory compliance.",
    image: "/assets/optimized/database-administrator",
  },
  {
    id: "pharma",
    title: "Pharmacists",
    description:
      "Qualified pharmacists supporting pharmaceutical operations and regulatory-driven workflows.",
    image: "/assets/optimized/pharmacist",
  },
];